import { BeforeProcessEndEventPayload, WIZARD_CONTROLLER } from '@mwe/features/wizard';
import { map, Observable, of, take } from 'rxjs';
import { inject, Injector } from '@angular/core';
import { PopupService } from '@mwe/services';
import { IPopupModelV2 } from '@mwe/models';
import { UmmeldungSavePopupComponent } from '../components';
import { Router } from '@angular/router';
import { ROUTE_UMMELDUNG_BESTAETIGUNG } from '../../../app.constants';

function ummeldungCustomConfirmExitDialog(event: BeforeProcessEndEventPayload): Observable<boolean> {
  if (event.reason === 'finished') {
    return of(false);
  }
  if (inject(Router).url.includes(ROUTE_UMMELDUNG_BESTAETIGUNG)) {
    return of(false);
  }
  const popupService = inject(PopupService);
  openUmmeldungExitPopup();
  return popupService.events().pipe(
    take(1),
    map(result => !result),
  );
}

function closeWithCustomConfirmExitDialog(): Observable<boolean> {
  const popupService = inject(PopupService);
  const wizardController = inject(WIZARD_CONTROLLER);
  openUmmeldungExitPopup();

  return popupService.events().pipe(
    take(1),
    map(result => {
      if (!result) {
        return true;
      }
      wizardController.close('finished');
      return result;
    }),
  );
}

function openUmmeldungExitPopup(): void {
  const UMMELDUNG_EXIT_POPUP: IPopupModelV2 = {
    id: 'ummeldung-confirm-exit',
    modalSize: 'md',
    component: UmmeldungSavePopupComponent,
    titleKey: 'ummeldung.confirmExitPopup.title',
    componentData: {
      messageKey: 'ummeldung.confirmExitPopup.description',
      iconColorClass: 'blue',
      iconTypeClass: 'fas fa-solid fa-question',
    },
    dismissable: false,
    modalOpts: { injector: inject(Injector) },
  };

  const popupService = inject(PopupService);
  popupService.openV2(UMMELDUNG_EXIT_POPUP);
}

export { ummeldungCustomConfirmExitDialog, closeWithCustomConfirmExitDialog };
